import { C as b } from "./component-B88NZlIm.js";
import { d as p } from "./utilities-D-QcnR4L.js";
import { E as g } from "./embla-tQScX_QI.js";
class v extends b {
  requiredRefs = ["viewport", "container"];
  embla = null;
  resizeObserver = null;
  mutationObserver = null;
  #t = null;
  #o = null;
  #e = null;
  #s = null;
  #h = !1;
  #c = !1;
  #l = !1;
  #i = !1;
  #b = 5e3;
  connectedCallback() {
    (super.connectedCallback(),
      this.#y(),
      this.refs.viewport.addEventListener("pointerdown", this.#S, { signal: this.signal }),
      window.addEventListener("pointerup", this.#p, { signal: this.signal }),
      window.addEventListener("pointercancel", this.#p, { signal: this.signal }),
      (this.resizeObserver = new ResizeObserver(() => {
        this.#d();
      })),
      this.resizeObserver.observe(this.refs.viewport),
      (this.mutationObserver = new MutationObserver((t) => {
        t.some((i) =>
          i.type !== "attributes" || i.attributeName !== "class" || !(i.target instanceof Element)
            ? !1
            : i.target.classList.contains("carousel-slide") || !!i.target.closest(".carousel-slide")
        ) && this.#d();
      })),
      this.mutationObserver.observe(this.refs.container, {
        attributes: !0,
        subtree: !0,
        attributeFilter: ["class"],
      }));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.embla?.destroy(),
      this.resizeObserver?.disconnect(),
      this.mutationObserver?.disconnect(),
      this.#P(),
      this.#t && clearTimeout(this.#t),
      this.#o && clearTimeout(this.#o));
  }
  get thumbnails() {
    return Array.isArray(this.refs.thumbnails) ? this.refs.thumbnails : [];
  }
  #y() {
    const t = {
      loop: this.dataset.loop !== "false",
      align: this.dataset.align || "start",
      containScroll: "trimSnaps",
      skipSnaps: !0,
      container: this.refs.container,
      slides: ".carousel-slide:not(.media-hidden):not(.is-hidden)",
      dragFree: this.dataset.dragFree === "true",
      slidesToScroll: parseInt(this.dataset.slidesToScroll) || 1,
      draggable: !0,
      resize: !0,
      focus: !0,
      slideChanges: !0,
    };
    ((this.embla = g(this.refs.viewport, t)),
      this.#L(),
      this.#T(),
      this.#C(),
      this.#A(),
      this.#I(),
      this.#a(),
      this.embla.on("select", () => this.#a()),
      this.embla.on("reinit", () => this.#a()),
      this.embla.on("scroll", () => this.#v()),
      this.embla.on("scrolloptimize", (a, i) => {
        const { willChange: s, translate3d: e } = i.detail;
        this.dataset.debug === "true" &&
          console.log("[Carousel] Scroll optimization:", { willChange: s, translate3d: e });
      }),
      (this.#o = setTimeout(() => {
        this.#a();
      }, 100)));
  }
  #d() {
    if (this.#h) {
      this.#c = !0;
      return;
    }
    (this.#t && clearTimeout(this.#t),
      (this.#t = setTimeout(() => {
        if (!this.isConnected || !this.embla) return;
        const t = this.embla.slideNodes(),
          a = t.filter(
            (l) =>
              l.offsetParent !== null &&
              !l.classList.contains("media-hidden") &&
              !l.classList.contains("is-hidden")
          ),
          i = typeof this.embla.selectedSnap == "function" ? this.embla.selectedSnap() : 0,
          s = t[i],
          e =
            s &&
            s.offsetParent !== null &&
            !s.classList.contains("media-hidden") &&
            !s.classList.contains("is-hidden"),
          r = a.length ? Math.max(0, t.indexOf(a[0])) : 0,
          n = e ? i : r;
        this.embla.reInit({
          startSnap: n,
          loop: this.dataset.loop !== "false",
          draggable: !0,
          resize: !0,
          focus: !0,
          slideChanges: !0,
        });
      }, 50)));
  }
  #S = () => {
    ((this.#h = !0), (this.#l = !0));
  };
  #p = () => {
    ((this.#h = !1), this.#c && ((this.#c = !1), this.#d()));
  };
  #a() {
    if (!this.embla) return;
    const t = this.embla.slideNodes().length;
    ((this.dataset.singleSlide = t <= 1 ? "true" : "false"),
      (this.dataset.scrollable = this.#r() ? "true" : "false"),
      this.#w(),
      this.#g(),
      this.#E(),
      this.#x(),
      this.#v());
  }
  #L() {
    !this.refs.prev ||
      !this.refs.next ||
      !this.embla ||
      (this.refs.prev.addEventListener(
        "click",
        () => {
          ((this.#l = !0), this.embla && (this.embla.goToPrev(), this.#n()));
        },
        { signal: this.signal }
      ),
      this.refs.next.addEventListener(
        "click",
        () => {
          ((this.#l = !0), this.embla && (this.embla.goToNext(), this.#n()));
        },
        { signal: this.signal }
      ));
  }
  #w() {
    if (!this.refs.prev || !this.refs.next || !this.embla) return;
    if (this.dataset.loop !== "false") {
      ((this.refs.prev.style.display = ""), (this.refs.next.style.display = ""));
      return;
    }
    ((this.refs.prev.style.display = this.embla.canGoToPrev() ? "" : "none"),
      (this.refs.next.style.display = this.embla.canGoToNext() ? "" : "none"));
  }
  #r() {
    if (!this.embla) return !0;
    if (
      this.embla
        .slideNodes()
        .filter(
          (n) =>
            n.offsetParent !== null &&
            !n.classList.contains("media-hidden") &&
            !n.classList.contains("is-hidden")
        ).length <= 1
    )
      return !1;
    const i = this.refs.viewport,
      s = this.refs.container,
      e = i?.clientWidth ?? 0;
    return e > 0 && s ? !(s.scrollWidth - e <= 1) : this.embla.snapList().length > 1;
  }
  #T() {
    !this.querySelector(".carousel-dots") || !this.embla || this.#g();
  }
  #g() {
    const t = this.querySelector(".carousel-dots");
    if (!t || !this.embla) return;
    const i = this.embla
        .slideNodes()
        .filter((c) => c.offsetParent !== null && !c.classList.contains("media-hidden")),
      e = this.embla.snapList().length;
    if (i.length <= 1) {
      t.style.display = "none";
      return;
    }
    if (!this.#r()) {
      t.style.display = "none";
      return;
    }
    t.style.display = "";
    const n = this.embla.selectedSnap(),
      l = Math.max(0, Math.min(n, e - 1)),
      o = Array.from(t.querySelectorAll(".carousel-dot"));
    if (o.length !== e)
      ((t.innerHTML = Array.from({ length: e }, (d, h) => {
        const u = h + 1,
          f = h === l,
          m = `carousel-snap-${h}`;
        return `<button
          type="button"
          class="carousel-dot${f ? " is-active" : ""}"
          role="tab"
          aria-label="Go to slide ${u}"
          aria-selected="${f ? "true" : "false"}"
          aria-controls="${m}"
          tabindex="${f ? "0" : "-1"}"
        ></button>`;
      }).join("")),
        Array.from(t.querySelectorAll(".carousel-dot")).forEach((d, h) => {
          d.addEventListener(
            "click",
            () => {
              this.embla && (this.embla.goTo(h), this.#n());
            },
            !1
          );
        }));
    else {
      const c = o;
      c.length > 0 &&
        c.forEach((d, h) => {
          const u = h === l;
          (d.setAttribute("aria-selected", String(u)), d.classList.toggle("is-active", u));
        });
    }
  }
  #x() {
    const { current: t, total: a } = this.refs;
    if (!t || !this.embla) return;
    const i = this.embla.slideNodes(),
      s = i.filter((o) => o.offsetParent !== null && !o.classList.contains("media-hidden")),
      e = this.querySelector(".carousel-counter")?.closest(".carousel-controls");
    if (e && s.length <= 1) {
      e.style.display = "none";
      return;
    }
    if (e) {
      if (!this.#r()) {
        e.style.display = "none";
        return;
      }
      e.style.display = "";
    }
    const r = i[this.embla.selectedSnap()],
      n = s.indexOf(r),
      l = s.length;
    (t instanceof HTMLElement && (t.textContent = String(n + 1)),
      a instanceof HTMLElement && (a.textContent = String(l)));
  }
  #A() {}
  #v() {
    const { progressbar: t } = this.refs;
    if (!t || !this.embla) return;
    const i = this.embla
        .slideNodes()
        .filter((l) => l.offsetParent !== null && !l.classList.contains("media-hidden")),
      s = this.querySelector(".carousel-progressbar")?.closest(".carousel-controls");
    if (s && i.length <= 1) {
      s.style.display = "none";
      return;
    }
    if (s) {
      if (!this.#r()) {
        s.style.display = "none";
        return;
      }
      s.style.display = "";
    }
    const e = this.embla,
      r = typeof e.scrollProgress == "function" ? e.scrollProgress() : null;
    let n = 0;
    if (typeof r == "number" && !Number.isNaN(r)) n = Math.max(0, Math.min(1, r)) * 100;
    else {
      const l = this.embla.snapList()?.length ?? 0,
        o = this.embla.selectedSnap?.() ?? 0;
      n = l > 1 ? (Math.max(0, Math.min(l - 1, o)) / (l - 1)) * 100 : 0;
    }
    t instanceof HTMLElement && (t.style.width = `${n}%`);
  }
  #C() {
    !this.thumbnails.length ||
      !this.embla ||
      this.thumbnails.forEach((t, a) => {
        t.addEventListener(
          "click",
          () => {
            if (!this.embla) return;
            const i = t.getAttribute("data-media-position");
            if (i) {
              const e = this.embla
                .slideNodes()
                .findIndex((r) => r.getAttribute("data-media-position") === i);
              if (e >= 0) {
                (this.embla.goTo(e), this.#n());
                return;
              }
            }
            (this.embla.goTo(a), this.#n());
          },
          { signal: this.signal }
        );
      });
  }
  #E() {
    if (!this.thumbnails.length || !this.embla) return;
    const t = this.embla.slideNodes(),
      a = this.embla.selectedSnap(),
      s = t[a]?.getAttribute("data-media-position") || null;
    if (
      (this.thumbnails.forEach((e, r) => {
        const n = s ? e.getAttribute("data-media-position") === s : r === a;
        (e.setAttribute("aria-selected", String(n)),
          e.setAttribute("tabindex", n ? "0" : "-1"),
          e.classList.toggle("is-active", n));
      }),
      this.#l)
    ) {
      const e =
        (s
          ? this.thumbnails.find((r) => r.getAttribute("data-media-position") === s)
          : this.thumbnails[a]) || null;
      e &&
        this.refs.thumbnailsContainer &&
        e.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  }
  #I() {
    this.dataset.autoplay !== "true" ||
      !this.embla ||
      this.embla.snapList().length <= 1 ||
      ((this.#i = !0),
      (this.#b = parseInt(this.dataset.autoplayDelay) || 5e3),
      this.refs.viewport.addEventListener(
        "pointerenter",
        () => {
          this.#f();
        },
        { signal: this.signal }
      ),
      this.refs.viewport.addEventListener(
        "pointerleave",
        () => {
          this.#N();
        },
        { signal: this.signal }
      ),
      this.#u());
  }
  #u() {
    !this.#i ||
      this.#e ||
      (this.#e = setInterval(() => {
        this.embla.canGoToNext() ? this.embla.goToNext() : this.embla.goTo(0);
      }, this.#b));
  }
  #f() {
    this.#e && (clearInterval(this.#e), (this.#e = null));
  }
  #P() {
    ((this.#i = !1), this.#f(), this.#m());
  }
  #n() {
    this.#i &&
      (this.#f(),
      this.#m(),
      (this.#s = setTimeout(() => {
        this.#u();
      }, 3e3)));
  }
  #N() {
    this.#i &&
      (this.#m(),
      (this.#s = setTimeout(() => {
        this.#u();
      }, 1e3)));
  }
  #m() {
    this.#s && (clearTimeout(this.#s), (this.#s = null));
  }
}
p("carousel-embla", v);
export { v as CarouselEmbla };
